import { Theme, css } from '@emotion/react';

export const offeringDetailsSimpleRoot = ({ colors, transitions }: Theme) => css`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: space-between;
  flex: 1;
  border: 1px solid ${colors.borderDefault};
  transition: border ${transitions.duration.short}ms ${transitions.easing.easeInOut} 0ms;
  &:hover {
    border: 1px solid ${colors.borderDefault};
    @media (hover: none) {
      border: 1px solid ${colors.borderDefault};
    }
  }
`;

export const offeringDetailsSimpleContent = ({ breakpoints, spacing }: Theme) => css`
  padding: ${spacing(2)}px ${spacing(2)}px 0 ${spacing(2)}px;
  margin-bottom: ${spacing(2)}px;
  flex: 1 0 auto;
  ${breakpoints.up('md')} {
    padding: ${spacing(3)}px ${spacing(3)}px 0 ${spacing(3)}px;
  }
  &:last-child {
    padding: ${spacing(2)}px ${spacing(2)}px 0 ${spacing(2)}px;
    ${breakpoints.up('md')} {
      padding: ${spacing(3)}px ${spacing(3)}px 0 ${spacing(3)}px;
    }
  }
`;

export const offeringDetailsSimpleActions = ({ breakpoints, spacing }: Theme) => css`
  padding: 0 ${spacing(2)}px ${spacing(2)}px ${spacing(2)}px;
  ${breakpoints.up('md')} {
    padding: 0 ${spacing(3)}px ${spacing(3)}px ${spacing(3)}px;
  }
  & .Consumer-menuLink {
    margin-left: ${spacing(2)}px;
  }
  & span.MuiButton-root {
    position: static;
  }
`;

export const offeringDetailsSimpleCtaTimes = ({ breakpoints }: Theme) => css`
  display: flex;
  overflow: hidden;
  width: 100%;
  & button:nth-of-type(4) {
    display: none;
    ${breakpoints.up('md')} {
      display: flex;
    }
  }
`;
